import { createFileRoute } from "@tanstack/react-router";

import { ScreenMainWrapper } from "@/blocks/ScreenMainWrapper";
import Dashboard from "@/interactors/Dashboard";
import { headWithCustomTitle } from "@/utils/router";

const RouteComponent = () => {
  return (
    <ScreenMainWrapper titleI18nKey="main:dashboard.title">
      <Dashboard />
    </ScreenMainWrapper>
  );
};

export const Route = createFileRoute("/_authed/admin/")({
  component: RouteComponent,
  head: () => headWithCustomTitle("main:dashboard.title"),
});
